import React from 'react'
import Regenerate from './Regenerate.svg';
import styles from './Regenerate.module.css';
import { useDispatch } from 'react-redux';
import { handleChatAndMessage } from '../../redux/shared/actions.js';
import { regenerateButton } from '../../redux/message/actions.js';

function RegenerateButton({ user_id, existingChatId, chatHistory, navigate, existingAssistantMessageId }) {
  const dispatch = useDispatch();
  
  const handleClick = () => {
    chatHistory = chatHistory.slice(0, chatHistory.length - 1);
    const lastUserMessage = chatHistory.filter(message => message.role === 'user').pop();
    dispatch(handleChatAndMessage(user_id, existingChatId, lastUserMessage.content, chatHistory, navigate, true, existingAssistantMessageId));
    dispatch(regenerateButton(user_id, existingAssistantMessageId))
  }

  return (
    <img 
      className={styles.image}
      src={Regenerate} 
      alt="Regenerate"
      onClick={handleClick} 
    />
  );
}

export default RegenerateButton;